<div class="address-finder-wrap">
  <mat-form-field class="fill">
    <mat-label>Addresseingabe</mat-label>

    <input matInput [(ngModel)]="searchTerm" (input)="getAmenity()" [matAutocomplete]="auto" />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onAddressSelected($event)">
      @for (option of searchResult; track option) {
        <mat-option [value]="option">
          {{ option.formatted }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <div>
    <p>
      name: {{ location?.street }} {{ location?.housenumber }}; postcode: {{ location?.postcode }};
      city: {{ location?.city }};
    </p>
  </div>
</div>
